import React, { useEffect, useState, useContext } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useQuery } from 'react-query';
import { getPaymentClearanceById } from '../../../../api/apiServices';

const ViewPaymentClearance = () => {

    const params = useParams();
    const id = parseInt(params.id)

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/payment_transactions";

    const {
        isLoading,
        isError,
        error,
        data: paymtClearance
    } = useQuery(['paymtClearance', id], () => getPaymentClearanceById(id));

    console.log(paymtClearance)

    const handleCancel = () => {
        navigate(-1);
    }

    const fullname = paymtClearance?.fullname;


    const memberInfo = (
        <>
            <legend style={{ color: "var(--white)" }}>Member Information</legend>
            <div className='table-responsive lg'>
                <table className='table table-borderled'>
                    <>
                        <tbody>
                            <tr>
                                <td>FULL NAME</td>
                                <td><b>{fullname}</b></td>
                                <td>MOBILE</td>
                                <td><b>{paymtClearance?.mobile_number}</b></td>
                                <td>PF NUMBER</td>
                                <td><b>{paymtClearance?.pf_number}</b></td>
                            </tr>
                        </tbody>
                    </>
                </table>
            </div>
        </>
    )
    let content
    if (isLoading) {
        content = <p>Loading Member Payment Transactions...</p>
    }
    else if (isError) {
        content = <p>{error.message}</p>
    } else {
        content =
            (
                <>
                    {/* Total Payment Transactions  */}
                    <legend>Payment Information</legend>
                    <div className="table-responsive lg">
                        <table className='table table-borderless table-striped'>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "center" }}>Payment Date</th>
                                    <th style={{ textAlign: "center" }}>Transaction ID</th>
                                    <th style={{}}>Payment Type</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Payment Mode</th>
                                    <th style={{ textAlign: "right" }}>Amount (GHS)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ textAlign: "center" }}>{paymtClearance.payment_date}</td>
                                    <td style={{ textAlign: "center" }}>{paymtClearance.transaction_id}</td>
                                    {paymtClearance.payment_type === 'MP' ?
                                        <td style={{ textTransform: "uppercase" }}>
                                            {'MANDATORY PAYMENT'}
                                        </td>
                                        : paymtClearance.payment_type === 'FD' ?
                                            <td style={{ textTransform: "uppercase" }}>
                                                {'FUNERAL DONATION'}
                                            </td>
                                            : paymtClearance.payment_type === 'DN' ?
                                                <td style={{ textTransform: "uppercase" }}>
                                                    {'DONATION'}
                                                </td>
                                                : paymtClearance.payment_type === 'SD' ?
                                                    <td style={{ textTransform: "uppercase" }}>
                                                        {'SPECIAL DONATION'}
                                                    </td>
                                                    : <td style={{ textTransform: "uppercase" }}>
                                                        {paymtClearance.payment_type}
                                                    </td>
                                    }
                                    {paymtClearance.payment_mode === 'M' ?
                                        <td style={{ textTransform: "uppercase" }}>
                                            {'MOBILE MONEY PAYMENT'}
                                        </td>
                                        : paymtClearance.payment_mode === 'Q' ?
                                            <td style={{ textTransform: "uppercase" }}>
                                                {'CHEQUE PAYMENT'}
                                            </td>
                                            : paymtClearance.payment_type === 'B' ?
                                                <td style={{ textTransform: "uppercase" }}>
                                                    {'VISA/CREDIT/DEBIT CARD PAYMENT'}
                                                </td>
                                                : null
                                    }
                                    <td style={{ textAlign: "right" }}>{paymtClearance.payment_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            )
    }

    return (
        <>
            <section className="content-header">
                <h1>Payment Details</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            {memberInfo}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                            <div className="panel-footer">
                                <div className="form-group row">
                                    <div className="col-sm-2">
                                        <button onClick={handleCancel} className="btn btn-success">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ViewPaymentClearance